import { getXDateFormat } from 'App/Map/PanelDetails/StackemCharts/_utils/by-domain/_utils/getXDateFormat'
import type { HighchartsOptionsWithSemiosAdditions } from 'components/StackedChart/types'
import type { Moment } from 'moment-timezone'

export const applyAWCChartOverrides = ({
  chartConfig,
  soilDateFrom,
  soilDateTo,
}: {
  chartConfig: HighchartsOptionsWithSemiosAdditions
  soilDateFrom: Moment
  soilDateTo: Moment
}): HighchartsOptionsWithSemiosAdditions => {
  return {
    ...chartConfig,
    chart: {
      ...chartConfig.chart,
      events: {
        ...chartConfig.chart?.events,
        selection: function () {
          return false
        },
      },
    },
    tooltip: {
      enabled: false,
      xDateFormat: getXDateFormat(false),
    },
    plotOptions: {
      ...chartConfig?.plotOptions,
      series: {
        ...(chartConfig?.plotOptions?.series ?? {}),
        states: {
          ...(chartConfig?.plotOptions?.series?.states ?? {}),
          hover: {
            enabled: false,
            halo: {
              size: 0,
            },
          },
        },
        marker: {
          ...(chartConfig?.plotOptions?.series?.marker ?? {}),
          states: {
            ...(chartConfig?.plotOptions?.series?.marker?.states ?? {}),
            hover: {
              enabled: false,
              radiusPlus: 0,
            },
            select: {
              enabled: false,
            },
          },
        },
      },
    },
    xAxis: {
      ...chartConfig.xAxis,
      min: soilDateFrom.valueOf(),
      max: soilDateTo.valueOf(),
      crosshair: false,
      plotBands: [],
    },
  }
}

export const applyHeatmapChartOverrides = ({
  chartConfig,
}: {
  chartConfig: HighchartsOptionsWithSemiosAdditions
}): HighchartsOptionsWithSemiosAdditions => {
  return {
    ...chartConfig,
    tooltip: {
      enabled: false,
      xDateFormat: getXDateFormat(false),
    },
    chart: {
      ...chartConfig.chart,
      events: {
        ...chartConfig.chart?.events,
        selection: function () {
          return false
        },
      },
    },
    plotOptions: {
      ...chartConfig?.plotOptions,
      heatmap: {
        ...(chartConfig?.plotOptions?.heatmap ?? {}),
        enableMouseTracking: false,
        states: {
          ...(chartConfig?.plotOptions?.heatmap?.states ?? {}),
          hover: {
            enabled: false,
            halo: {
              size: 0,
            },
          },
        },
      },
    },
    xAxis: {
      ...chartConfig.xAxis,
      crosshair: false,
      plotBands: [],
    },
  }
}
